import React from "react";
import Menu from "./menu";
import { Divider } from "primereact/divider";

const Layout = ({ header, children }) => {
  return (
    <div
      className="flex flex-column w-full"
      style={{
        boxSizing: "border-box",
        overflowX: "hidden",
        minHeight: "100vh",          // ocupa toda la altura de la pantalla
      }}
    >
      <header
        className="flex w-full align-items-center justify-content-between site-header"
        style={{
          minHeight: "4.5rem",
          background: "rgba(255,255,255,0.97)",
          boxShadow: "0 2px 8px 0 rgba(0,0,0,0.06)",
          position: "sticky",
          top: 0,
          zIndex: 10,
        }}
      >
        <Menu />
      </header>

      {/* Contenido: conserva tu layout actual */}
      <div className="flex flex-grow-1 justify-content-center pt-4">
        <div>{header}</div>
        <div>{children}</div>
      </div>

      {/* Footer: se “pega” abajo si falta contenido */}
      <div
        className="flex align-items-center justify-content-between w-full footer h-6rem"
        style={{ marginTop: "auto" }}   // empuja el footer al fondo
      >
        <div>
          <ul role="navigation" className="unstyledList footerMenu">
            <li>
              <a className="footerMenuItem" href="/terms">
                Términos y condiciones
              </a>
            </li>
          </ul>
        </div>
        <div>
          <small className="footerCopyright">
            © 2022 textum - Automated credit. Todos los derechos reservados.
          </small>
        </div>
      </div>
    </div>
  );
};

export default Layout;
